import { createFileRoute } from '@tanstack/react-router';

import { Friends } from '#modules/user/features/friends/components/Friends';
import { parseFriendsTab, type FriendsTab } from '#modules/user/features/friends/model/tabs';

export const Route = createFileRoute('/{-$locale}/_layout/_dashboard/_authed/dashboard/friends')({
  component: Friends,
  // Вкладка живёт в адресе, а не в состоянии: ссылку на «подписчиков» можно отправить, «назад»
  // возвращает на предыдущую вкладку, перезагрузка не сбрасывает на первую. Неизвестное значение
  // молча становится вкладкой по умолчанию — чужой адрес не должен показывать пустой экран.
  validateSearch: (search: Record<string, unknown>): { tab?: FriendsTab } => ({
    tab: search.tab === undefined ? undefined : parseFriendsTab(search.tab),
  }),
  // Списки связей — личные и меняются между визитами; серверный рендер их всё равно
  // не переиспользует, а гидратация пустого экрана дороже одного клиентского запроса.
  ssr: false,
});
